import ModalValidityCreate from './ModalValidityCreate';
import ModalValidityDelete from './ModalValidityDelete';
import ModalValidityFilter from './ModalValidityFilter';
import ModalValidityUpdate from './ModalValidityUpdate';

export default Object.assign(
  {},
  {
    Create: ModalValidityCreate,
    Update: ModalValidityUpdate,
    Delete: ModalValidityDelete,
    Filter: ModalValidityFilter,
  },
);
